import { Service, computed, inject, signal } from '@angular/core';
import { MultiSesionService } from './multi-sesion.service';

/**
 * Indice de la sesion activa, tomado del parametro `:id` de la ruta.
 * A diferencia de FrontKordata, se actualiza en cada navegacion y no solo
 * al arrancar la aplicacion.
 */
@Service()
export class SessionStore {
  private readonly multiSesion = inject(MultiSesionService);
  private readonly indiceActivo = signal(-1);

  readonly indice = this.indiceActivo.asReadonly();
  readonly sesionActiva = computed(() => this.multiSesion.obtener(this.indiceActivo()));
  readonly token = computed(() => this.sesionActiva()?.token ?? null);

  setIndice(indice: number): void {
    this.indiceActivo.set(Number.isInteger(indice) && indice >= 0 ? indice : -1);
  }
}
